import polyfills from './polyfills'; // eslint-disable-line no-unused-vars
import React from 'react'; // eslint-disable-line no-unused-vars
import styles from './styles'; // eslint-disable-line no-unused-vars

import { render } from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import { Provider } from 'react-redux';

import {routes} from './constants';
import store from './store';
import { initResources } from './utils';
import {
    HomePage,
    TestDescriptionsPage,
    SamplingGuidelinesPage,
    FlushingConvertingProcedurePage,
    ContactPage,
    FAQPage,
    Navigator,
    LoginPage,
    RegistrationPage,
    UserManagementPage,
    AccountVerifyPage,
    SubmittedPage,
    SampleTrendingPage,
    DeniedPage,
    ForgotPasswordPage,
    PasswordResetPage,
    AccountPage,
    SetSecurityPage,
    ExternalLoginPage
} from './containers';

initResources();

render((
    <Provider store={store}>
        <Router history={browserHistory}>
            <Route path={routes.HOME} component={Navigator}>
                <IndexRoute component={HomePage}/>
                <Route path={routes.TEST_DESCRIPTIONS} component={TestDescriptionsPage} />
                <Route path={routes.SAMPLING_GUIDELINES} component={SamplingGuidelinesPage} />
                <Route path={routes.FLUSHING_CONVERTING_PROCEDURE} component={FlushingConvertingProcedurePage} />
                <Route path={routes.FAQ} component={FAQPage} />
                <Route path={routes.CONTACT} component={ContactPage} />
                <Route path={routes.LOGIN} component={LoginPage} />
                <Route path={routes.REGISTER} component={RegistrationPage} />
                <Route path={routes.USER_MANAGEMENT} component={UserManagementPage} />
                <Route path={routes.VERIFY} component={AccountVerifyPage} />
                <Route path={routes.SUBMITTED} component={SubmittedPage} />
                <Route path={routes.SAMPLE_TRENDING_FORMAT} component={SampleTrendingPage} />
                <Route path={routes.DENIED} component={DeniedPage} />
                <Route path={routes.FORGOT_PASSWORD} component={ForgotPasswordPage} />
                <Route path={routes.RESET_PASSWORD} component={PasswordResetPage} />
                <Route path={routes.ACCOUNT} component={AccountPage} />
                <Route path={routes.SET_SECURITY} component={SetSecurityPage} />
                <Route path={routes.EXTERNAL_LOGIN} component={ExternalLoginPage} />
            </Route>
        </Router>
    </Provider>
), document.getElementById('react-wrapper'));



// WEBPACK FOOTER //
// ./web-app/app.jsx